import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { Link } from 'react-router-dom';
import { IntegrationWebhook } from '../Component/Integration Component/IntegrationWebhook';
import { LeedintegrationKeys } from '../Component/Integration Component/LeedintegrationKeys';
export const Integrationpage = () => {
  const [userlogin, setuserlogin] = useState('');
  useEffect(() => {
    if (JSON.parse(localStorage.getItem('user')) != null) {
      setuserlogin(JSON.parse(localStorage.getItem('user')));
    }
  }, []);

  // تحديد المسارات بناءً على دور المستخدم
  const homeRoute =
    userlogin?.data?.role === 'Admin'
      ? '/AllLeadsForAdmin'
      : userlogin?.data?.role === 'Marketer'
        ? '/ALLLeadsForMarketer'
        : '/'; // fallback

  return (
    <Container className="startpage">
      <Row>
        <Col sm={2}></Col>
        <Col sm={10}>
          <div>
            <div>
              <Link to={homeRoute} style={{ textDecoration: 'none', color: '#102dff' }}>
                <span style={{ fontWeight: 'bold' }}>Home</span>
              </Link>
              <KeyboardDoubleArrowRightIcon />

              <span style={{ color: '#666' }}>Integration</span>
            </div>
          </div>

          <div style={{ marginTop: '20px', color: '#666' }}> Choose Data To Create Webhook URL</div>
          <hr />

          <IntegrationWebhook />
          <LeedintegrationKeys />
        </Col>
      </Row>
    </Container>
  );
};
